import { Instance } from 'mobx-state-tree'

import { TournamentModelBase } from './TournamentModel.base'

/* The TypeScript type of an instance of TournamentModel */
export interface TournamentModelType extends Instance<typeof TournamentModel> {}

/* A graphql query fragment builders for TournamentModel */
export { selectFromTournament, tournamentModelPrimitives, TournamentModelSelector } from './TournamentModel.base'

/**
 * TournamentModel
 */
export const TournamentModel = TournamentModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
